import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import {
  CustomComponent,
  UsersProfileServiceInterface,
  EMAIL_PATTERN,
  USERS_PROFILE_SERVICE_TOKEN
} from '@cakeiteasy/web-utils';

import { UserManager } from '../../../users/services/user.manager';
import { IUser } from '../../../users/models/i-user';
import { getUser } from '../../../users/store/selectors';
import { UserState } from '../../../users/store/reducers/user.reducer';

@Component({
  standalone: false,
  selector: 'my-account',
  templateUrl: './my-account.component.html'
})
export class MyAccountComponent extends CustomComponent implements OnInit {
  public user: IUser;
  public basicInfoForm: FormGroup = new FormGroup({});
  public updateInfoError: string;
  public countryCode: string;
  public busy: Promise<any>;
  public EMAIL_PATTERN = EMAIL_PATTERN;

  constructor(@Inject(USERS_PROFILE_SERVICE_TOKEN) public profileService: UsersProfileServiceInterface,
              private _store: Store<UserState>,
              private _fb: FormBuilder,
              private _users: UserManager) {
    super();
  }

  async ngOnInit() {
    this.countryCode = await (this.busy = this.profileService.getCountryCode());

    // Moved forms initializing from constructor to OnInit hook
    this.basicInfoForm = this._fb.group({
      email: [{ value: '', disabled: true }, [Validators.required, Validators.maxLength(128)]],
      fullName: ['', [Validators.required, Validators.maxLength(32)]],
      phone: ['', [Validators.required, Validators.maxLength(32)]],
    });

    this._subscribe();
  }

  public updateUserInfo() {
    this.updateInfoError = '';

    this._users.updateInfo(this.basicInfoForm.value)
      .then(() => {
        this.basicInfoForm.markAsPristine();
      })
      .catch(() => {
        this.updateInfoError = 'Unexpected error';
      });
  }

  private _subscribe() {
    this.addSubscriber(this._store.select(getUser).subscribe((user: IUser) => {
      this.user = user;
      this.basicInfoForm.patchValue(Object.assign({}, user));
    }));
  }
}
